module.exports = __webpack_public_path__ + "media/images/elionline/icons/da_assegnare_assegna-fed674c18484fe226d9aa367b6a8f243.svg";